import { serializeError } from 'app/shared';
import axios, { AxiosResponse } from 'axios';
import { getOr } from 'lodash/fp';
import { redirectToLogin } from "../../routes/pagePathGenerator";

const apiUrl = import.meta.env.VITE_API_PORT
  ? `${import.meta.env.VITE_API_URL}:${import.meta.env.VITE_API_PORT}`
  : `${import.meta.env.VITE_API_URL || ''}`;
const baseURL = apiUrl + '/api';

export const request = axios.create({
  baseURL,
});

export const requestForDownloads = axios.create({
  baseURL,
});

export function setAxiosToken(token?:string) {
  request.defaults.headers.common['x-access-token'] = token;
  requestForDownloads.defaults.headers.common['x-access-token'] = token;
}

request.interceptors.response.use(
  (response: AxiosResponse) => getOr({}, 'data.data', response),
  (error) => {
    if (error.response.data.message === 'Token expired') {
      localStorage.removeItem('token');
      redirectToLogin();
    }
    return Promise.reject(error)
  }
);

export const editWirelessInterface = async (wirelessInterface) => {
  try {
    await request.put('/wireless-interface', wirelessInterface);
  } catch (error) {
    throw serializeError(error);
  }
};

export const deleteWirelessInterface = async (id: number) => {
  try {
    await request.delete('/wireless-interface', { data: { id } });
  } catch (error) {
    throw serializeError(error);
  }
};
